"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALIDATION_TYPE = void 0;
var VALIDATION_TYPE;
(function (VALIDATION_TYPE) {
    VALIDATION_TYPE[VALIDATION_TYPE["STRING"] = 0] = "STRING";
    VALIDATION_TYPE[VALIDATION_TYPE["PHONENUMBER"] = 1] = "PHONENUMBER";
    VALIDATION_TYPE[VALIDATION_TYPE["ZIPCODE"] = 2] = "ZIPCODE";
    VALIDATION_TYPE[VALIDATION_TYPE["EMAIL"] = 3] = "EMAIL";
    VALIDATION_TYPE[VALIDATION_TYPE["NUMBER"] = 4] = "NUMBER";
    VALIDATION_TYPE[VALIDATION_TYPE["NUMBERPOSITIVE"] = 5] = "NUMBERPOSITIVE";
    VALIDATION_TYPE[VALIDATION_TYPE["REGISTRATIONNUMBER"] = 6] = "REGISTRATIONNUMBER";
    VALIDATION_TYPE[VALIDATION_TYPE["ORG_NR"] = 7] = "ORG_NR";
})(VALIDATION_TYPE = exports.VALIDATION_TYPE || (exports.VALIDATION_TYPE = {}));
//# sourceMappingURL=validation.js.map